import { Divider, List, ListItemButton, ListItemIcon, ListItemText, ListSubheader } from '@mui/material'
import { Link } from 'react-router-dom'
import HomeIcon from '@mui/icons-material/Home'
import WhatshotIcon from '@mui/icons-material/Whatshot'
import ExploreIcon from '@mui/icons-material/Explore'
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt'
import AddIcon from '@mui/icons-material/Add'
import { CommunityAvatar } from './CustomAvatar'
import CommunityListLoading from './CommunityListLoading'
import PeopleIcon from '@mui/icons-material/People'
import CampaignIcon from '@mui/icons-material/Campaign'
import React from 'react'

export const BasicList = () => {
  return (
    <List
      component="nav"
      disablePadding
      sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
    >
      <ListItemButton to="/home" component={Link}>
        <ListItemIcon>
          <HomeIcon />
        </ListItemIcon>
        <ListItemText
          primary="Home"
          primaryTypographyProps={{ fontSize: '14px' }}
          sx={{ ml: -2 }}
        />
      </ListItemButton>
      <ListItemButton disabled>
        <ListItemIcon>
          <WhatshotIcon />
        </ListItemIcon>
        <ListItemText
          primary="Popular"
          primaryTypographyProps={{ fontSize: '14px' }}
          sx={{ ml: -2 }}
        />
      </ListItemButton>
      <ListItemButton disabled>
        <ListItemIcon>
          <ExploreIcon />
        </ListItemIcon>
        <ListItemText
          primary="Explore"
          primaryTypographyProps={{ fontSize: '14px' }}
          sx={{ ml: -2 }}
        />
      </ListItemButton>
      <ListItemButton disabled>
        <ListItemIcon>
          <SignalCellularAltIcon />
        </ListItemIcon>
        <ListItemText
          primary="All"
          primaryTypographyProps={{ fontSize: '14px' }}
          sx={{ ml: -2 }}
        />
      </ListItemButton>
    </List>
  )
}

export const CommunityList = ({ communities, createCommunityModalOpenHandler, loading }) => {
  return (
    <>
      <Divider variant="middle" sx={{ borderBottomWidth: 1 }}/>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            COMMUNITIES
          </ListSubheader>
        }
        disablePadding
        sx={{ width: '100%', maxWidth: 272, bgcolor: 'background.paper' }}
      >
        <ListItemButton onClick={createCommunityModalOpenHandler}>
          <ListItemIcon>
            <AddIcon/>
          </ListItemIcon>
          <ListItemText
            primary="Create a community"
            primaryTypographyProps={{ fontSize: '14px' }}
            sx={{ ml: -2 }}
          />
        </ListItemButton>
        {communities?.map(community => (
          <ListItemButton key={community.id} to={`communities/${community.id}`} component={Link}>
            <ListItemIcon>
              <CommunityAvatar src={community.avatarImageUrl} communityId={community.id} />
            </ListItemIcon>
            <ListItemText
              primary={community.id}
              primaryTypographyProps={{ fontSize: '14px' }}
              sx={{ ml: -2 }}
            />
          </ListItemButton>
        ))}
        <CommunityListLoading loading={loading}/>
      </List>
    </>
  )
}

export const AdminList = () => {
  return (
    <>
      <Divider variant="middle" sx={{ borderBottomWidth: 1 }}/>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            ADMIN
          </ListSubheader>
        }
        disablePadding
        sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
      >
        <ListItemButton to="/users" component={Link}>
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText
            primary="Users"
            primaryTypographyProps={{ fontSize: '14px' }}
            sx={{ ml: -2 }}
          />
        </ListItemButton>
        <ListItemButton to="/reported-posts" component={Link}>
          <ListItemIcon>
            <CampaignIcon />
          </ListItemIcon>
          <ListItemText
            primary="Reported Posts"
            primaryTypographyProps={{ fontSize: '14px' }}
            sx={{ ml: -2 }}
          />
        </ListItemButton>
        <ListItemButton to="/reported-comments" component={Link}>
          <ListItemIcon>
            <CampaignIcon />
          </ListItemIcon>
          <ListItemText
            primary="Reported Comments"
            primaryTypographyProps={{ fontSize: '14px' }}
            sx={{ ml: -2 }}
          />
        </ListItemButton>
      </List>
    </>
  )
}
